<template>
  <div>
    <form
      container
      @submit.prevent="submitAddForm({ recipientName, recipientEmail })"
    >
      <div class="card _pxs _pys ">
        <h2>Add Recipient</h2>
        <div grid>
          <div column="4">
            <app-input
              v-model="$v.recipientName.$model"
              :invalid="$v.recipientName.$invalid"
              :errorMessage="recipientNameError"
              valueKey="recipientName"
              label="Recipient name"
            />
          </div>
          <div column="5">
            <app-input
              v-model="$v.recipientEmail.$model"
              :invalid="$v.recipientEmail.$invalid"
              :errorMessage="recipientEmailError"
              valueKey="recipientEmail"
              label="Recipient Email"
            />
          </div>
        </div>
        <div class="_text-center">
          <button
            class="_mls _mrs --sm sun"
            @click.prevent="$emit('closeAddRecipient')"
          >
            cancel
          </button>

          <app-async-button
            type="submit"
            class="_mls _mrs --sm"
            :disabled="$v.$invalid"
          >
            <template #buttonContent>
              <span>Submit</span>
            </template>
          </app-async-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import AppInput from '@atoms/Input'
  import AppAsyncButton from '@molecules/AsyncButton.vue'
  import { required, email, maxLength } from 'vuelidate/lib/validators'
  import { nameAlphaNumeric } from '@/utils'
  import * as mutationTypes from '@store/modules/clientOnboardingManagement/mutationTypes'

  export default {
    data() {
      return {
        defaultTitle: 'Add Recipient',
        recipientName: '',
        recipientEmail: ''
      }
    },
    components: {
      AppInput,
      AppAsyncButton
    },
    methods: {
      submitAddForm(value) {
        this.$store.commit(mutationTypes.SET_ADD_RECIPIENT, {
          name: value.recipientName,
          email: value.recipientEmail
        })
        this.$emit('closeAddRecipient')
      }
    },
    computed: {
      addRecipientTitle() {
        if (!this.recipientName) {
          return this.defaultTitle
        }
        return this.recipientName
      },
      recipientNameError() {
        if (!this.$v.recipientName.required) {
          return 'required'
        } else if (!this.$v.recipientName.maxLength) {
          return 'character limit exceeded'
        } else if (!this.$v.recipientName.nameAlphaNumeric) {
          return 'only letters, spaces, numbers, *, and - allowed'
        }
        return null
      },
      recipientEmailError() {
        if (!this.$v.recipientEmail.required) {
          return 'required'
        } else if (!this.$v.recipientEmail.email) {
          return 'not a valid email address'
        } else if (!this.$v.recipientEmail.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      cancelRoute() {
        const applicationId = this.$route.params.applicationId
        if (applicationId) {
          return {
            name: 'recipients',
            params: { applicationId: applicationId }
          }
        }

        return {
          name: 'recipients'
        }
      }
    },
    validations: {
      recipientName: {
        required,
        maxLength: maxLength(27),
        nameAlphaNumeric
      },
      recipientEmail: {
        email,
        required,
        maxLength: maxLength(77)
      }
    }
  }
</script>

<style></style>
